import styled, { createGlobalStyle } from 'styled-components';
import { Dropdown } from 'primereact/dropdown';
import media from 'src/styles/Media.styled';
import { PRIMARY_FONT_COLOR, TERTIARY_FONT_COLOR, DISABLED_FONT_COLOR, SMALL_TEXT_PX, X_SMALL_TEXT_PX, BASE_TEXT_PX } from '../../../styles/fonts/MCFontConstants';

export const AlertSelectPanelStyles = createGlobalStyle`
    .alerts-action-panel.p-dropdown-panel .p-dropdown-items {
        padding: 0rem;
    }
    .alerts-sort-panel.p-dropdown-panel .p-dropdown-items {
        padding: 0rem;
    }
    .alerts-sort-panel.p-dropdown-panel .p-dropdown-item {
        font-size: 14px !important;
    }
`;

export const SelectContainer = styled(Dropdown).attrs(
    ({
        value,
        options,
        onChange,
        onFocus,
        onBlur,
        editable,
        onInputChange,
        isSearchable,
        consignmentBilling,
        consignmentAdd,
        isSortMobileView
        // sortIcon,
    }) => ({
        value: value,
        options: options,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        editable: editable,
        consignmentBilling: consignmentBilling,
        consignmentAdd: consignmentAdd,
        // sortIcon:sortIcon,
        onInputChange: onInputChange,
        isSearchable: isSearchable,
        appendTo:isSortMobileView?'self':''
    })
)`
    &.p-dropdown {
        margin-right: ${({ marginRight }) => `${marginRight} !important`};
        width: ${({ width }) => (width ? width : '100%')};
        height: ${({ height }) => (height ? height : '40px')};
        border-radius: ${({ borderRadius }) => borderRadius};
        border-color: ${({ borderColor }) =>
            borderColor ? borderColor : '#0000003b'};
margin-left : ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
        @media only screen and (max-device-width: 375px) {
            width: ${({ smWidth, width }) =>
                smWidth ? smWidth : width ? width : '100%'};
        }
        @media only screen and (max-device-width: 576px) {
            margin-bottom: ${({ mbMarginBottom }) =>
            mbMarginBottom ? mbMarginBottom : ''};
            border-radius: ${({ mbBorderRadius }) =>
                mbBorderRadius ? mbBorderRadius : ''};
        }
               @media screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait){
     margin-left: ${({ ipadMarginLeft }) => (ipadMarginLeft ? ipadMarginLeft : '')};
     width:${({ iPadwidth }) => (iPadwidth ? iPadwidth : '')};

    }
    @media screen and (min-width: 800px) and (max-width: 825px) and (orientation: portrait){
     margin-left: ${({ ipadMarginLeft }) => (ipadMarginLeft ? ipadMarginLeft : '')};
     width:${({ iPadwidth }) => (iPadwidth ? iPadwidth : '')};

    }

        @media only screen and (max-device-width: 360px) {
            width: ${({ xSmWidth, width }) =>
                xSmWidth ? xSmWidth : width ? width : '100%'};
        }
        @media only screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait) {
            width: ${(props) =>
                props.consignmentBilling || props.consignmentAdd
                    ? '100%'
                    : ''};
        }
        @media only screen and (min-width: 820px) and (max-width: 820px) and (orientation: portrait) {
            width: ${(props) =>
                props.consignmentBilling || props.consignmentAdd
                    ? '100%'
                    : ''};
        }
        @media only screen and (min-width: 1024px) and (max-width: 1024px) and (orientation: portrait) {
            width: ${(props) =>
                props.consignmentBilling ?
                    '100%':
                    props.consignmentAdd
                    ? '100%'
                    : ''};
        }
    }
    &.p-dropdown:hover {
        border: 1px solid #000000 !important;
    }
    &.p-dropdown.p-focus {
        box-shadow: unset;
        border: 1px solid #000000;
    }

    & .p-dropdown-label::before {
        content: ${(props) =>
            props.isFromConsignmentAddProductGuide || props.isFromInventoryConsignment
                ? `url(${props.sortIcon})`
                : 'none'};
        // position: absolute;
        left: 0.5rem;
        top: 50%;
        width: ${(props) => props.sortIconWidth ? props.sortIconWidth : (props.isFromConsignmentAddProductGuide ? '22px' : '16px')};
        transform: ${(props) => props.sortIconScale ? `translateY(-50%) scale(${props.sortIconScale})` : 'translateY(-50%)'};
        height: 16px;
        pointer-events: none;
        margin-top:${(props) => (props.isFromConsignmentAddProductGuide ? '7px' : '8px')};
        ${media.mobileDevice`     
     margin: ${({ sortIcon, sortIconRightMargin }) => (sortIcon ? `11px ${sortIconRightMargin || '5px'} 0 5px` : '0px')};
     `}
    }

    &.p-inputtext {
        width: 100%;
    }
    &.p-dropdown:enabled:hover {
        border-color: unset;
    }
    &.p-dropdown:enabled:focus {
        box-shadow: 0 0 0 0.2rem white;
        border-color: #ccc !important;
    }
    &.p-dropdown:enabled:hover {
        border-color: unset;
    }
    &.p-dropdown:enabled:focus {
        box-shadow: 0 0 0 0.2rem white;
        border-color: #ccc !important;
    }
    &.p-button:not(a):not(.p-disabled):active {
        color: #6c757d !important;
    }
    &.p-button:not(a):not(.p-disabled):hover {
        color: #6c757d !important;
    }
    &.p-button {
        background-color: white !important;
        color: #6c757d;
        border: 1px solid #ccc !important;
        border-left: 0px;
        border-left: 0px;
        border-left-color: white !important;
    }
    &.p-dropdown .p-dropdown-label.p-placeholder {
        color: ${(props) => (props.labelColor ? props.labelColor : TERTIARY_FONT_COLOR)};
    }
    
    &.p-dropdown-panel .p-dropdown-items .p-dropdown-item {
        padding: 0.6rem 0.5rem;
        font-family: 'AvenirNextWorld Regular !important';
        font-size: ${X_SMALL_TEXT_PX} !important;

    }
    &.p-disabled {
        color: ${DISABLED_FONT_COLOR} !important;
    }
    &.p-highlight {
        width: unset !important;
        background-color: #cfe8fe !important;
        height: unset !important;
    }
    &.p-dropdown .p-dropdown-label {
        font-size: ${(props) =>
            props.selectedLabelFontSize ? props.selectedLabelFontSize : BASE_TEXT_PX};
        font-family: ${(props) =>
            props.selectedLabelfontFamily
                ? props.selectedLabelfontFamily
                : 'AvenirNextWorld Regular'};
        display: flex;
        align-items: center;
        color: ${(props) => props.labelColor ? props.labelColor : (props.isFromConsignmentAddProductGuide ? '#140f4b' : PRIMARY_FONT_COLOR)};
        margin-right: ${(props) => (props.isFromConsignmentAddProductGuide && !props.sortMarginRight?
            '38px' :props.mbMarginRight ? props.mbMarginRight : 'none')};
        ${({ truncateLabel }) => truncateLabel && `
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            > span {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        `}
    }

    &.p-dropdown .p-dropdown-clear-icon {
        margin-right: ${(props) =>
            props.crossIconMargin ? props.crossIconMargin : 'unset'};
        right: ${({ right }) => right};
    }

    &.p-dropdown .p-dropdown-trigger .p-dropdown-trigger-icon.pi-chevron-down {
        content: url(${(props) => props.downArrowIcon});
    }

    &.p-dropdown .p-dropdown-trigger {
        width: 1.1rem !important;
        margin-right: 10px !important;
    }

    &.p-dropdown .p-dropdown-panel{
        ${media.mobileDevice` 
            font-size: ${(props) => (props.isSortMobileView ? SMALL_TEXT_PX : '')};  
            `}
        }
    
    @media only screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait) {
        width: ${(props) => (props.consignmentBilling ? '100%' : '')};
    }
`;
